(() => {
  document.querySelectorAll('[data-predictive-search]').forEach((container) => {
    const input = container.querySelector('[data-predictive-search-input]');
    const results = container.querySelector('[data-predictive-search-results]');
    if (!input || !results) return;

    let controller;
    let timer;

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        results.hidden = true;
        return;
      }

      timer = window.setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const url = `${window.JataraoTheme.routes.predictiveSearch}?q=${encodeURIComponent(query)}&section_id=predictive-search&resources[type]=product,collection,page,article&resources[limit]=8`;

        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return;
          results.innerHTML = await response.text();
          results.hidden = false;
        } catch (error) {
          if (error.name !== 'AbortError') results.hidden = true;
        }
      }, 220);
    });

    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        results.hidden = true;
        input.focus();
      }
    });
  });
})();
